// ============================================================
// trash - deleted assets wait 30 days, then go for good. Pure.
//
// The PocketBase server empties it daily (pb_hooks/assets.pb.js); Firebase
// runs no server code, so the owner's page empties it when it opens.
// ============================================================
import { ROOT, type AssetRow, type FolderRow } from './types';

export const TRASH_DAYS = 30;
const DAY_MS = 86_400_000;

/** Has a trashed asset waited its 30 days? */
export function expired(asset: AssetRow, now: number): boolean {
  return asset.deletedAt > 0 && now - asset.deletedAt >= TRASH_DAYS * DAY_MS;
}

/** Whole days before a trashed asset leaves, never below zero. */
export function daysLeft(asset: AssetRow, now: number): number {
  return Math.max(0, TRASH_DAYS - Math.floor((now - asset.deletedAt) / DAY_MS));
}

/** The row in the Trash: it remembers where it was. */
export function trashed(asset: AssetRow, now: number): AssetRow {
  return { ...asset, deletedAt: now, trashedFrom: asset.folderId, updatedAt: now };
}

/** The row restored: to the folder it left, or to My assets when that folder is gone. */
export function restored(asset: AssetRow, folders: readonly FolderRow[], now: number): AssetRow {
  const home = folders.some((f) => f.id === asset.trashedFrom) ? asset.trashedFrom : ROOT;
  return { ...asset, deletedAt: 0, folderId: home, trashedFrom: ROOT, updatedAt: now };
}
